import { Download } from "lucide-react";
import { Button } from "@shared/ui/Button";
import { Image } from "@shared/ui/Image";

export type Props = {
  alt: string;
  src: string;
  downloadUrl: string;
  label: string;
};

export function DownloadableAssetImage({
  alt,
  src,
  downloadUrl,
  label = "Download image",
}: Props) {
  return (
    <div className="overflow-hidden flex flex-col rounded-md border border-brand-800 gap-0">
      <div className="w-full">
        <div className="overflow-hidden">
          <Image src={src} alt={alt} className="w-full object-contain" />
        </div>
      </div>
      <div className="flex justify-center px-6 py-6 border-t border-brand-800">
        <Button
          as="a"
          href={downloadUrl}
          target="_blank"
          download
          title="Download"
          aria-label="Download"
          variant="secondary"
          size="sm"
          iconComponent={Download}
          data-testid="downloadable-asset-image-download"
        >
          {label}
        </Button>
      </div>
    </div>
  );
}

export default DownloadableAssetImage;
